(ns app.front.view.group.admin.standard-texts.phrases
  (:require [app.front.ui :as ui]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.phrases :as phrases]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub]]))

(defn section []
  (let [tr       (<sub [::gas/group-tr])
        group-id (<sub [::gas/group-id])]
    [acommon/section {}
     [ui/help (tr [:group-admin/phrases-instruction]) {:class "mb-8 p-2"}]
     [phrases/phrase-management group-id]]))
